import { env } from "@src/env.mjs";

const serverUrl = env.NEXT_PUBLIC_SERVER_URL;

const billingProxyServerUrl =
  env.NEXT_PUBLIC_PROXY_SERVER_URL + "?dest=billingapi";

const baseServerPlansUrl = billingProxyServerUrl + "/plan/";

export const serverEndpoints = {
  serverUrl: serverUrl,
  reverseProxy: serverUrl + "/reverseProxy",
  deleteUserFromSystem: serverUrl + "/deleteUserFromSystem",
  userImpersonation: serverUrl + "/impersonateUser",
  getAddOn: (subscriptionId: number) =>
    billingProxyServerUrl + `/addOn?subscriptionId=${subscriptionId}`,
  addPaymentToSub: billingProxyServerUrl + `/payment/add-to-sub`,
  updateAddOn: billingProxyServerUrl + `/addOn/update`,
  changePlan: billingProxyServerUrl + `/subscription/change-plan`,
  createAddOn: billingProxyServerUrl + `/addOn/create`,
  userSubs: billingProxyServerUrl + "/subscription/all-by-userid",
  proxy: (dest?: string) => serverUrl + `/proxy${dest ? `?dest=${dest}` : ""}`,
  createScreen: serverUrl + "/createScreen",
  unpairScreen: serverUrl + "/unpairScreen",
  uploadAsset: serverUrl + "/uploadAsset",
  uploadVideo: serverUrl + "/uploadVideo",
  finalizeVideoUpload: serverUrl + "/finalizeVideoUpload",
  getPlans: baseServerPlansUrl + "all",
  updatePlan: baseServerPlansUrl + "update",
  createPlan: baseServerPlansUrl + "create",
  deletePlan: baseServerPlansUrl + "delete",
  uploadThumbnail: serverUrl + "/uploadThumbnail",
  uploadPluginThumbnailAsset: serverUrl + "/uploadPluginThumbnailAsset",
  authenticateBrowserPlayer: serverUrl + "/authenticateBrowserPlayer",
  getUserApps: serverUrl + "/getUserApps",
  extendFreeTrial: serverUrl + "/extendFreeTrial",

  aiBuilderCommand: serverUrl + "/ai/builder/command",
  aiBuilderOptimizeLayout: serverUrl + "/ai/builder/optimize-layout",
  aiBuilderGenerateVisualElement: serverUrl + "/ai/builder/generate-visual-element",
  aiBuilderEnhanceElement: serverUrl + "/ai/builder/enhance-element",
  aiBuilderGenerateContent: serverUrl + "/ai/builder/generate-content",
  aiBuilderGenerateImage: serverUrl + "/ai/builder/generate-image",
  aiBuilderGenerateLayout: serverUrl + "/ai/builder/generate-layout",

  // Studio auth (server-side)
  studioAuthOtpRequest: serverUrl + "/studioAuth/otp-request",
  studioAuthOtpVerify: serverUrl + "/studioAuth/otp-verify",
  studioAuthPasswordLogin: serverUrl + "/studioAuth/password-login",
  studioAuthRefresh: serverUrl + "/studioAuth/refresh",
  studioAuthSignout: serverUrl + "/studioAuth/signout",
  studioAuthUser: serverUrl + "/studioAuth/user",

  // Data proxy
  dataProxy: serverUrl + "/data",

  // Music API proxy
  musicProxy: serverUrl + "/music",
} as const;
